<template>
  <div class="page">
    <accordion :multiple="true" :activeIndex="[0, 1]" >
      <accordion-tab>
        <template #header>
          <span>Stai per modificare {{ data_.pdrIds.length }} {{ (data_.pdrIds.length != 1)? 'pdrs': 'pdr' }}</span>
        </template>

        <div class="formgrid grid">
          
          <div class="field col-12 md:col-4">
            <label for="data_inizio">Data Inizio - Nuova offerta</label>
            <calendar 
              id="data_inizio" 
              v-model="dataInizio" 
              :showIcon="true" 
              view="month" 
              dateFormat="01/mm/yy" 
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_offerta">Offerta</label>
            <dropdown 
              id="cod_offerta" 
              v-model="data_.item.cod_offerta" 
              :filter="true"
              :options="data_.listaOfferte" 
              optionLabel="label" 
              optionValue="id" 
              placeholder="Seleziona offerta..." 
              class="inputfield w-full"
            />
          </div>

          <div class="field col-12 md:col-4">
            <div class="flex align-items-center checkbox-align">
            <checkbox v-model="data_.item.multisito" :binary="true" />
            <label for="multisito" class="ml-2">Multisito</label>
          </div>
          </div>

        </div>

        <div class="p-d-flex p-p-3 card">
          <prime-button 
            label="Modifica offerte" 
            icon="pi pi-file-o" 
            class="mb-auto"
            :disabled="( success )" 
            @click="onUpdateButton($event)" 
          />
        </div>

      </accordion-tab>

      <accordion-tab v-if="result.valid.length > 0">
        <template #header>
          <span>{{ (result.valid.length != 1)? 'Sono stati creati': "E' stato creato" }} {{result.valid.length }} {{ (result.valid.length != 1)? 'nuovi contratti': 'nuovo contratto' }}</span>
        </template>

        <data-table 
          :value="result.valid" 
          dataKey="id" 

          sortMode="multiple"
          responsiveLayout="scroll" 

          :paginator="true" 
          :rows="10"
          :rowsPerPageOptions="[10,25,50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" 
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"  
        >
          <column field="code" header="PDR" :sortable="true">
            <template #body="{ data }">
              <router-link
                :to="`/ask/pdrs/${data.id}/dettagli`"
                custom
                v-slot="{ href }"
              >
                <prime-button 
                  :label="`${data.code}`" 
                  class="p-button-info p-button-text"
                  @click="navigateToTab(href)" 
                />
              </router-link>
            </template>
          </column>

          <column header="Contratto">
            <template #body="{ data }">
              <router-link
                :to="`/ask/contratti/vendita/${data.contratto.id}/dettagli`"
                custom
                v-slot="{ href }"
              >
                <prime-button 
                  :label="`${data.contratto.code}`" 
                  class="p-button-info p-button-text"
                  @click="navigateToTab(href)" 
                />
              </router-link>
            </template>
          </column>

          <column header="Data Inizio Contratto">
            <template #body="{data}">
              <span>
                {{ (data.contratto.data_inizio !== null)? moment(data.contratto.data_inizio).format('DD/MM/YYYY'): '' }} 
              </span>
            </template>
          </column>
          
        </data-table>

      </accordion-tab>

      <accordion-tab v-if="result.failed.length > 0">
        <template #header>
          <span>Non è stato possibile modificare {{result.failed.length }} {{ (result.failed.length != 1)? 'pdrs': 'pdr' }}</span>
        </template>

        <div class="formgrid grid">
          <div 
            v-for="pod in result.failed " :key="pod.id"
            class="field col-12 md:col-2"
          >
            
            <router-link  :to="`/ask/pdrs/${pod.id}/dettagli`"
              custom
              v-slot="{ href }"
            >
              <prime-button 
                icon="pi pi-file-o" 
                :label="pod.code"
                class="mb-auto" 
                @click="navigateToTab(href)" 
              />
            </router-link>

          </div>
        </div>

      </accordion-tab>

      <accordion-tab v-if="result.missed.length > 0">
        <template #header>
          <span>Non è stato possibile modificare {{result.missed.length }} {{ (result.missed.length != 1)? 'pdrs': 'pdr' }} - ID non {{ (result.missed.length != 1)? 'presenti': 'presente' }} nel DB</span>
        </template>

        <div class="formgrid grid">
          <div 
            v-for="pod in result.missed " :key="pod.id"
            class="field col-12 md:col-2"
          >
            <span>PDR id {{ pod.id }} non trovato</span>
          </div>
        </div>

      </accordion-tab>
    </accordion>

    <Dialog :visible="showErrorDialog" :modal="true" :closable="false" :breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '50vw'}" @hide="onErrorDialogHide">
      <template #header>
        <h5>Errore</h5>
      </template>
      <div class="p-3">
        {{ errorMessage }}
      </div>
      <template #footer>
        <Button 
          label="Chiudi" 
          icon="pi pi-times"
          iconPos="right" 
          class="p-button-secondary mr-3"
          @click="onErrorDialogHide" 
        />
      </template>
    </Dialog>

  </div>
</template>

<script>
import moment from 'moment'

import Service from '@/services/ask-management/offerte-service'
import UtilityService from '@/services/ask-management/utility-service'

import PrimeButton from 'primevue/button'
import Checkbox from 'primevue/checkbox'
import Dialog from 'primevue/dialog'

export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  
  components: {
    PrimeButton,
    Checkbox,
    Dialog
  },

  data() {
    return {
      page:{
        name: 'pdrs-cambia-offerta',
      },

      moment,

      success: false,
      showErrorDialog: false,
      errorMessage: '',

      data_: {
        item: {
          data_inizio: null,
          cod_offerta: -1,
          multisito: false,
        },
        pdrIds: this.data,
      },

      result: {
        valid: [],
        failed: [],
        missed:[],
      },

      listaOfferte: [],
    }
  },

  created(){
    this.service = new Service(this.$http, this.$eventBus)

    this.utilityService = new UtilityService(this.$http, this.$eventBus)
    this.getListaOfferte()
  },

  methods:{

    onCancelButton(){
      this._reset()

      this.$eventBus.emit('dialog-return-cancel-button', {})
    },

    ////

    onUpdateButton(/** event **/){
      const ids = [...this.data_.pdrIds]

      const data = Object.entries({...this.data_.item})
      .map(([key, value])=>{
        if( key.startsWith('cod_') ){
          if(value == -1){
            value = null
          }
        }

        if( typeof(value) == 'string' ){
          value.trim()
          if( value == '' ){
            value = null
          }
        }

        return [key, value]
      })
      .reduce((obj, [key, value]) => {
        return {
          ...obj,
          [key]: value
        };
      }, {})

      const len = Object.values(data)
      .filter( (value) => value !== null )
      .length

      if(len == 3){
     
        this.service.updateMassivoOfferte({
          data,
          filters: {
            'pdr.ids': ids
          },
        }).then((res) => {
          const hasClientiDiversiError = res.items.some(item => 
            item.success === false && 
            item.error && 
            (item.error.includes('clienti diversi in modalità multisito') || 
             item.error.includes('clienti diversi'))
          );

          if (hasClientiDiversiError) {
            this.errorMessage = 'Non è stato possibile modificare l\'offerta in modo massivo in quanto i clienti sono diversi';
            this.showErrorDialog = true;
            return;
          }

          this.result.valid = res.items.filter( (el)=> el.success === true )
          
          this.result.failed = res.items
          .filter( (el)=> el.success === false )
          .filter( (el) => el.code != '' )

          this.result.missed = res.items
          .filter( (el)=> el.success === false )
          .filter( (el) => el.code == '' )
        })

        this.success = true
        
      }else{
        this.errorMessage = 'Nulla da modificare';
        this.showErrorDialog = true;
      }
    },

    onErrorDialogHide(){
      this.showErrorDialog = false
    },

    _reset(){
      this.success = false
      this.showErrorDialog = false
      this.errorMessage = ''

      this.data_.pdrIds = []  

      this.data_.item.data_inizio = null
      this.data_.item.cod_offerta = -1
      this.data_.item.multisito = false

      this.result.valid = []
      this.result.failed = []
      this.result.missed = []

      this.listaOfferte = []    
    },

    navigateToTab(href){
      window.open(href, '_blank')
    },

    getListaOfferte(){
      this.utilityService.getListaOfferteAttive().then((res) => {
        const items = res.items
        .sort( (a,b) => new Date(b.data_inizio) - new Date(a.data_inizio) )
        .map((el) => {
          const date = moment(el.data_inizio, 'YYYY-MM-DD').format('DD/MM/YYYY')
          const label = `${el.name} - ${date}`
          return {
            id: el.id,
            label
          }
        })
        
        items.unshift({
          id: -1,
          label: 'Nessuno'
        })

        this.data_.listaOfferte = items
      })
    },
  },

  computed:{
    dataInizio: {
      get: function() {
        return (this.data_.item.data_inizio !== null && this.data_.item.data_inizio !== '')? moment(this.data_.item.data_inizio).toDate(): null
      },
      set: function(value) {
        if(value instanceof Date && !isNaN(value.valueOf())){
          this.data_.item.data_inizio = moment(value).format('YYYY-MM-DD')
        }

        if( (value === null) || (value === '')){
          this.data_.item.data_inizio = null
        }
      }
    },
  },
}
</script>

<style scoped>
  .checkbox-align {
  margin-top: 2.2rem; 
  margin-left: 1.5rem;
}
</style>
